<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Quotes</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home
            </router-link>
            <span class="breadcrumb-item active">Quotes</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="">
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Company</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Pickup Date</th>
                    <th>From Zip</th>
                    <th>From Location</th>
                    <th>To Zip</th>
                    <th>To Location</th>
                    <th>Non Commercial Delivery</th>
                    <th>Extra Delivery Service</th>
                    <th>No Of Items</th>
                    <th>Packaging</th>
                    <th>Weight</th>
                    <th>Length</th>
                    <th>Width</th>
                    <th>Height</th>
                    <th>Freight Class</th>
                    <th>Is Hazardous</th>
                    <th>Submitted On</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="quote in quotes" :key="quote.id">
                    <td>{{quote.id}}</td>
                    <td>{{quote.company}}</td>
                    <td>{{quote.name}}</td>
                    <td>{{quote.email}}</td>
                    <td>{{quote.phone}}</td>
                    <td>{{quote.pickup_date}}</td>
                    <td>{{quote.ship_from_zip}}</td>
                    <td>{{quote.ship_from_location_type}}</td>
                    <td>{{quote.ship_to_zip}}</td>
                    <td>{{quote.ship_to_location_type}}</td>
                    <td>{{quote.non_commercial_delivery}}</td>
                    <td>{{quote.extra_delivery_service}}</td>
                    <td>{{quote.no_of_items}}</td>
                    <td>{{quote.packaging}}</td>
                    <td>{{quote.weight}}</td>
                    <td>{{quote.length}}</td>
                    <td>{{quote.width}}</td>
                    <td>{{quote.height}}</td>
                    <td>{{quote.freight_class}}</td>
                    <td>{{quote.is_hazardous}}</td>
                    <td>
                      <span style="display:none;">
                        {{new Date(quote.created_at).getTime()}}
                      </span>
                      {{quote.created_at}}
                    </td>
                    <td>
                      <i class="fa fa-trash fa-icons" @click="deleteQuote(quote.id)" aria-hidden="true"></i>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Quote from '@/models/Quote'
export default {
  name: 'Quotes',
  data () {
    return {
      isLoading: false,
      datatable: null,
      quotes: []
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)
    this.fetchAllQuotes()
  },
  methods: {
    fetchAllQuotes () {
      this.quotes = []
      this.isLoading = true
      this.$store.dispatch('fetchAllQuotes')
        .then((result) => {
          result.data.quotes.forEach(quote => {
            this.quotes.push(new Quote(quote))
          })
          this.isLoading = false
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    deleteQuote (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this quote?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteQuote', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllQuotes()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        columnDefs: [{
          targets: 7,
          'orderable': false
        }],
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Quotes.vue